<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-shopping</v-icon>
                    Produtos
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="paginationOptions.search"
                        class="mr-3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        placeholder="Informe o Nome do Produto"
                        single-line
                        hide-details
                        @keydown="buscar()"
                        @click:append="buscar()"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-switch
                        v-model="products.active"
                        :label=" `Exibindo ${products.active? 'Ativos': 'Inativos'}`"
                        single-line
                        hide-details
                        class="mr-3"
                        style="width: 200px"
                        @change="buscar()"
                    ></v-switch>
                    <v-btn color="#3D1159"
                        dark :to="{ name: 'productCreate' }">
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>

                <v-alert type="warning" outlined v-show="!products"
                >Nenhum Produto Encontrado
                </v-alert
                >
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredProductsItems()"
                    :options.sync="options"
                    :server-items-length="products.totalItems"
                    :search.sync="paginationOptions.search"
                    item-key="id"
                    class="elevation-1"
                    v-show="products"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.salesPrice="{ item }">
                        {{ item.salesPrice | money }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{
                                        name: 'product',
                                        params: { id: item.id }
                                    }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>


            <!--            <v-row>-->
            <!--                <v-col md="12">-->
            <!--                    <v-card>-->
            <!--                        <v-card-title>-->
            <!--                            <v-icon class="mr-1">mdi-shopping</v-icon>-->
            <!--                            Produtos-->
            <!--                        </v-card-title>-->
            <!--                    </v-card>-->
            <!--                </v-col>-->

            <!--                <v-col md="12">-->
            <!--                    <v-row justify="center">-->
            <!--                        <v-col md="10">-->
            <!--                            <v-data-table-->
            <!--                                :headers="headers"-->
            <!--                                item-key="id"-->
            <!--                                class="elevation-1"-->
            <!--                                :items="product"-->
            <!--                            >-->
            <!--                                <template v-slot:item.actions="{ item }">-->
            <!--                                    <v-tooltip bottom>-->
            <!--                                        <template v-slot:activator="{ on, attrs }">-->
            <!--                                            <v-btn-->
            <!--                                                icon-->
            <!--                                                v-bind="attrs"-->
            <!--                                                v-on="on"-->
            <!--                                                :to="{-->
            <!--                                                    name: 'product',-->
            <!--                                                    params: { id: item.id }-->
            <!--                                                }"-->
            <!--                                            >-->
            <!--                                                <v-icon>mdi-eye</v-icon>-->
            <!--                                            </v-btn>-->
            <!--                                        </template>-->
            <!--                                        <span>Visualizar</span>-->
            <!--                                    </v-tooltip>-->
            <!--                                </template>-->
            <!--                            </v-data-table>-->
            <!--                        </v-col>-->
            <!--                    </v-row>-->
            <!--                </v-col>-->
            <!--            </v-row>-->
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";

import {PRODUCT_RESET_STATE, SET_PRODUCT_PAGINATION} from "@/store/mutations/product.type";
import {PRODUCT_SEARCH} from "@/store/actions/product.type";


export default {
    name: 'Products',
    props: {
        source: String
    },
    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(PRODUCT_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            store.commit(PRODUCT_RESET_STATE),
            store.dispatch(PRODUCT_SEARCH)
        ]).then(() => {
            next();
        });
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/products')){
            localStorage.removeItem('productsOptions')
            localStorage.removeItem('productPaginationOptions')
        }
    },
    data: () => ({
        options: {},
        paginationOptions: {},
        selected: [],
        headers: [
            {text: "Nome", value: "description", align: 'left'},
            {text: "Código", value: "code", align: 'left'},
            {text: "Marca", value: "brand", align: 'left'},
            {text: "Quantidade", value: "quantity", align: 'left'},
            {text: "Preço", value: "salesPrice", align: 'left'},
            {text: "Visualizar", value: "actions", sortable: false, align: 'center'}
        ],

    }),
    methods: {
        buscar() {
                const {sortBy, sortDesc, itemsPerPage, page} = this.options
                this.productPagination.search = this.paginationOptions.search

                store.commit(SET_PRODUCT_PAGINATION, {
                    page: page,
                    itemsPerPage: itemsPerPage,
                    orderBy: sortBy,
                    sortDesc: sortDesc[0]
                })
                store.dispatch(PRODUCT_SEARCH);
            
        },
        pushRouteToView(route) {
            this.$router.push({name: route})
        },
        filteredProductsItems() { 
            const items = this.products.items
            const search = this.productPagination.search ? this.productPagination.search.toLowerCase() : ""
            if(search){
                this.options.itemsPerPage = this.products.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else {
                if(this.options.itemsPerPage == this.products.totalItems){
                    this.options.itemsPerPage = 10
                }
                return items;
            } 
        }
    },
    mounted() {
        if (localStorage.getItem('productsOptions')){
            this.options = JSON.parse(localStorage.getItem('productsOptions'))
        }
        if (localStorage.getItem('productPaginationOptions')){
            this.paginationOptions = JSON.parse(localStorage.getItem('productPaginationOptions'))
        }
    },
    watch: {
        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('productsOptions', parsed)
            },
            deep: true,
        },
        paginationOptions: {
            handler(newSearch) {
                this.buscar()
                const parsed = JSON.stringify(newSearch)
                localStorage.setItem('productPaginationOptions', parsed)
            },
            deep: true,
        }
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["products", "checkUsers", "productPagination"])
    },

}
</script>